export default {
  setAssetList(state, AssetList) {
    state.assetList = AssetList
  },
  setAsset(state, Asset) {
    // The event kinds checkbox group needs an array, even for a new asset.
    state.asset = Asset
      ? { ...Asset, event_kinds: Asset.event_kinds ?? [] }
      : Asset
  },
  setAssetMetadata(state, metadata) {
    state.assetMetadata = metadata
  },
  setAssetActivity(state, activity) {
    state.assetActivity = activity
  }
}
